module.exports = __webpack_public_path__ + "img/map_finish.816e531b.png";